module.exports = __webpack_public_path__ + "static/media/humidity_icon.74c35255.svg";